// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2lVLM","inputWrap":"Table_inputWrap__11OLA","col":"Table_col__3L8Sf","bmiTooltip":"Table_bmiTooltip__C6IK9"};